export { SUPPLEMENTS_CONTAINER_ID } from '@hungryroot/rest';
export const SUPPLEMENTS_OCCASION_ID = 7;
export const SUPPLEMENTS_CONTAINER_NAME = 'Supplements';
export const ADD_ONS_OCCASION_GROUP_ID = 4;
export const MAX_SUBSCRIPTION_PRODUCT_QUANTITY = 3;
export const SUPPLEMENTS_SELECTOR_PARAM = 'supplements-selector';
